import { forwardRef } from 'react';

import { Form, FormItemProps, Input, InputProps, InputRef } from 'antd';
import classNames from 'classnames';

import './InputFormItem.scss';

type TInputFormItemProps = {
	formItemProps: FormItemProps;
	inputProps: InputProps;
};

export const InputFormItem = forwardRef<InputRef, TInputFormItemProps>(
	({ formItemProps, inputProps }, ref) => {
		return (
			<Form.Item
				{...formItemProps}
				className={classNames('input', formItemProps.className)}
				rules={formItemProps?.rules ?? [{ required: true }]}
			>
				<Input {...inputProps} ref={ref} />
			</Form.Item>
		);
	},
);
InputFormItem.displayName = 'InputFormItem';
